import { applyNgo } from "appState/auth/authSlice";
import { TKIconSpinner } from "assets/images/svgs";
import { useFormik } from "formik";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import InputField from "shared/InputField";
import { ngoSignUpValidationSchema2 } from "validation/ngo/signupSchema2";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const Contact = ({ next, body }) => {
  const dispatch = useDispatch();
  const [phone, setPhone] = useState("");

  const { isLoading } = useSelector((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      contact_name: "",
      contact_number: "",
      contact_email: "",
    },
    validationSchema: ngoSignUpValidationSchema2,
    onSubmit: (values) => {
      const contactBody = {
        contact_name: values.contact_name,
        contact_number: phone,
        contact_email: values.contact_email,
        location: "location",
        ig_page: "ig_page",
      };
      dispatch(applyNgo({ ...body, ...contactBody })).then((data) => {
        const { payload } = data;
        if (payload?.status === 200) {
          toast.success("NGO application successfully");
          next();
        }
      });
    },
  });

  return (
    <div>
      <div className="mb-2 w-full">
        <p className="text-[20px] font-bold mb-2">NGO Contact Form</p>
        <div className="flex items-center mb-8 justify-start gap-2">
          <p className="text-[#7A7A7A]">
            Kindly provide details of a key contact person (preferable a key
            decision maker within the organization)
          </p>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit} className="w-full mb-6">
        <div className="flex flex-col gap-4 w-full">
          <div className="w-full flex flex-col gap-2">
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="contact_name"
              label="Name"
              placeholder="Peace Charity"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contact_name}
            />
            {formik.touched.contact_name && formik.errors.contact_name ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.contact_name}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">Contact Number</label>
            <PhoneInput
              placeholder="+2349012345678"
              country={"ng"}
              onlyCountries={["ng", "gh", "ke"]}
              value={phone}
              onChange={setPhone}
              onBlur={formik.handleBlur}
              inputProps={{
                name: "phone",
                required: true,
                autoFocus: true,
              }}
            />
            {formik.touched.phone && formik.errors.phone ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.phone}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="contact_email"
              label="Email Address"
              placeholder="example@test.com"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contact_email}
            />
            {formik.touched.contact_email && formik.errors.contact_email ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.contact_email}
              </p>
            ) : null}
          </div>
          <div className="mb-6">
            <button
              type="submit"
              className="w-full h-[50px] rounded-lg bg-[#213874] hover:bg-[#182d62] px-4 py-2 flex items-center justify-center"
            >
              <p className="text-white font-semibold">
                {isLoading ? <TKIconSpinner /> : "Apply"}{" "}
              </p>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Contact;
